import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const EmailForm = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Mock email for testing purposes
  const MOCK_EMAIL = 'test.user@example.com';

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex?.test(email);
  };

  const handleEmailChange = (e) => {
    const value = e?.target?.value;
    setEmail(value);

    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const handleMockEmailClick = () => {
    setEmail(MOCK_EMAIL);
    // Clear any existing errors
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    // Validate email
    if (!email?.trim()) {
      setError('لطفاً آدرس ایمیل خود را وارد کنید');
      return;
    }

    if (!validateEmail(email)) {
      setError('لطفاً آدرس ایمیل معتبری وارد کنید');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Simulate API call for OTP sending
      await new Promise((resolve) => setTimeout(resolve, 2000));

      // Store email in localStorage for next step
      localStorage.setItem('authEmail', email);

      // Navigate to OTP verification
      navigate('/otp-verification');
    } catch (err) {
      setError('خطا در ارسال کد تأیید. لطفاً دوباره تلاش کنید');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div className="bg-card rounded-lg shadow-moderate p-6 sm:p-8">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="flex items-center justify-center w-16 h-16 bg-primary rounded-full mx-auto mb-4">
            <Icon name="Scale" size={32} color="white" />
          </div>
          <h1 className="text-2xl font-bold text-card-foreground mb-2">
            ورود به ایران‌داد
          </h1>
          <p className="text-muted-foreground">
            برای دسترسی به مشاوره حقوقی، آدرس ایمیل خود را وارد کنید
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Input
              type="email"
              label="آدرس ایمیل"
              placeholder="example@email.com"
              value={email}
              onChange={handleEmailChange}
              error={error}
              required
              disabled={isLoading}
              className="text-left"
              dir="ltr"
            />

            {/* Mock Email Button for Testing */}
            <div className="flex justify-end">
              <button
                type="button"
                onClick={handleMockEmailClick}
                disabled={isLoading}
                className="text-xs text-primary hover:text-primary/80 underline disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                استفاده از ایمیل آزمایشی
              </button>
            </div>
          </div>

          <Button
            type="submit"
            variant="default"
            size="lg"
            fullWidth
            loading={isLoading}
            disabled={!email?.trim() || isLoading}>
            {isLoading ? 'در حال ارسال...' : 'ارسال کد تأیید'}
          </Button>
        </form>

        {/* Help Text */}
        <div className="mt-6 p-4 bg-muted rounded-lg">
          <div className="flex items-start space-x-reverse space-x-3">
            <Icon
              name="Info"
              size={20}
              className="text-muted-foreground mt-0.5 flex-shrink-0"
            />
            <div className="text-sm text-muted-foreground">
              <p className="font-medium mb-1">راهنما:</p>
              <ul className="space-y-1">
                <li>• کد تأیید به ایمیل شما ارسال خواهد شد</li>
                <li>• کد تأیید ۵ دقیقه اعتبار دارد</li>
                <li>• در صورت عدم دریافت، پوشه اسپم را بررسی کنید</li>
                <li>• برای تست سریع، از "ایمیل آزمایشی" استفاده کنید</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Security Notice */}
        <div className="mt-4 text-center">
          <p className="text-xs text-muted-foreground">
            اطلاعات شما با رمزگذاری امن محافظت می‌شود
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailForm;
